if (!customElements.get('landing-product-grid')) {
  customElements.define('landing-product-grid', class LandingProductGrid extends HTMLElement {
    constructor() {
      super();
      this.page = 1;
      this.narrowBy = [];
      this.genderFacetKey = 'Isp-tag-Gender';
      this.activeFacet = '';
      this.activeTag = '';
    }

    connectedCallback() {
      this.productsWrap = this.querySelector('[data-products-wrap]');
      this.loadMoreBtn = this.querySelector('[data-action="lcg-load-more"]');
      this.productsPerPage = parseInt(this.dataset.perPage) || 8;
      this.collectionId = this.dataset.collectionId || null;

      this.initListeners();
      this.waitForFastSimon();
    }

    waitForFastSimon() {
      const interval = setInterval(() => {
        if (window.FastSimonSDK) {
          clearInterval(interval);
          this.loadPage(true);
        }
      }, 50);
    }

    initListeners() {
      // Gender toggle
      this.querySelectorAll('[data-gender-toggle] input').forEach(input => {
        input.addEventListener('change', () => {
          this.page = 1;
          this.rebuildNarrowBy();
          this.loadPage(true);
        });
      });

      // Category pills
      this.querySelectorAll('[data-filter-pills] [data-filter-tag]').forEach(btn => {
        btn.addEventListener('click', () => {
          const facet = btn.dataset.filterFacet;
          const tag = btn.dataset.filterTag;
          const isActive = btn.classList.contains('active');

          this.querySelectorAll('[data-filter-tag]').forEach(b => {
            b.classList.remove('active');
          });

          if (!isActive) {
            btn.classList.add('active');
            this.activeFacet = facet;
            this.activeTag = tag;
          } else {
            this.activeFacet = '';
            this.activeTag = '';
          }

          this.page = 1;
          this.rebuildNarrowBy();
          this.loadPage(true);
        });
      });

      // Load more
      this.loadMoreBtn?.addEventListener('click', () => {
        this.page++;
        this.loadPage(false);
      });
    }

    rebuildNarrowBy() {
      this.narrowBy = [];

      const gender = this.querySelector(`input[name="${this.genderFacetKey}"]:checked`)?.value || '';
      if (gender) this.narrowBy.push([this.genderFacetKey, gender]);

      if (this.activeFacet && this.activeTag) this.narrowBy.push([`Isp-tag-${this.activeFacet}`, this.activeTag]);
    }

    loadPage(replace) {
      if (!this.productsWrap) return;

      if (replace) this.renderSkeleton();

      window.FastSimonSDK.smartCollections({
        categoryID: this.collectionId,
        page: this.page,
        narrowBy: this.narrowBy,
        sortBy: 'relevency',
        productsPerPage: this.productsPerPage,
        callback: (response) => {
          const payload = response.payload;
          const products = payload?.products || [];
          const isLastPage = payload?.pageCount <= this.page;

          if (replace) this.productsWrap.innerHTML = '';

          products.forEach(product => {
            this.productsWrap.insertAdjacentHTML(
              'beforeend',
              `<intersection-loader data-url="${product.u}" data-section-id="product-tile"></intersection-loader>`
            );
          });

          if (this.loadMoreBtn) {
            this.loadMoreBtn.style.display = isLastPage ? 'none' : '';
          }
        }
      });
    }

    renderSkeleton() {
      this.productsWrap.innerHTML = Array.from({ length: this.productsPerPage }).map(() => `
        <div class="aspect-[78/100] bg-secondaryLight rounded-lg animate-pulse"></div>
      `).join('');
    }
  });
}
